
window.extend = (object, mixin) ->
  for name, method of mixin
    object[name] = App.Helpers.Objects.deep_clone(method)

  mixin

window.include = (klass, mixin) ->
  extend klass.prototype, mixin
